import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

const RiskReportDocDark = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 60 55.596" {...props}>
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5908"
            data-name="Rectangle 5908"
            width="60"
            height="55.596"
            transform="translate(0 0)"
            fill="#8990a7"
          />
        </clipPath>
      </defs>
      <g
        id="Group_16778"
        data-name="Group 16778"
        transform="translate(0 0)"
        style={{ isolation: 'isolate' }}
      >
        <g id="Group_16777" data-name="Group 16777" clipPath="url(#clip-path)">
          <path
            id="Path_7658"
            data-name="Path 7658"
            d="M60,25A23,23,0,1,1,37,2,23,23,0,0,1,60,25"
            fill="#b3c2dc"
          />
          <path
            id="Path_7659"
            data-name="Path 7659"
            d="M9,1,1,9V53H36V1Z"
            fill="#8990a7"
          />
          <path
            id="Path_7660"
            data-name="Path 7660"
            d="M49.51,50.475l-12.9-12.9-3.536,3.536,12.9,12.9a2,2,0,0,0,2.828,0l.707-.707a2,2,0,0,0,0-2.828"
            fill="#8990a7"
          />
          <path
            id="Path_7661"
            data-name="Path 7661"
            d="M1,10h9V1H9L1,9Z"
            fill="#8990a7"
          />
          <path
            id="Path_7662"
            data-name="Path 7662"
            d="M36,13V1H9L1,9V53H36V49"
            fill="#465165"
            stroke="#b3c2dc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Path_7663"
            data-name="Path 7663"
            d="M36.611,37.575l12.9,12.9a2,2,0,0,1,0,2.829l-.707.707a2,2,0,0,1-2.828,0l-12.9-12.9"
            fill="#465265"
            stroke="#b4c2dc"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <rect
            id="Rectangle_5900"
            data-name="Rectangle 5900"
            width="4"
            height="6"
            rx="1"
            transform="translate(45 7.5)"
            fill="#b3c2db"
            stroke="#465266"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <rect
            id="Rectangle_5901"
            data-name="Rectangle 5901"
            width="4"
            height="6"
            rx="1"
            transform="translate(45 31)"
            fill="#b3c2db"
            stroke="#465266"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            id="Line_9"
            data-name="Line 9"
            y2="8"
            transform="translate(56 21)"
            fill="none"
            stroke="#465165"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <path
            id="Path_7664"
            data-name="Path 7664"
            d="M40,28A16,16,0,1,1,24,12,16,16,0,0,1,40,28"
            fill="#8990a7"
          />
          <circle
            id="Ellipse_343"
            data-name="Ellipse 343"
            cx="16"
            cy="16"
            r="16"
            transform="translate(8 12)"
            fill="#465265"
            stroke="#b4c2dc"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <rect
            id="Rectangle_5902"
            data-name="Rectangle 5902"
            width="5"
            height="7"
            transform="translate(16 28)"
            fill="#8990a7"
          />
          <rect
            id="Rectangle_5903"
            data-name="Rectangle 5903"
            width="5"
            height="7"
            transform="translate(16 28)"
            fill="#465265"
            stroke="#b4c2dc"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <rect
            id="Rectangle_5904"
            data-name="Rectangle 5904"
            width="5"
            height="14"
            transform="translate(21 21)"
            fill="#8990a7"
          />
          <rect
            id="Rectangle_5905"
            data-name="Rectangle 5905"
            width="5"
            height="14"
            transform="translate(21 21)"
            fill="#465265"
            stroke="#b4c2dc"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <rect
            id="Rectangle_5906"
            data-name="Rectangle 5906"
            width="5"
            height="10"
            transform="translate(26 25)"
            fill="#8990a7"
          />
          <rect
            id="Rectangle_5907"
            data-name="Rectangle 5907"
            width="5"
            height="10"
            transform="translate(26 25)"
            fill="#465265"
            stroke="#b4c2dc"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <path
            id="Path_7665"
            data-name="Path 7665"
            d="M5,10h5V5"
            fill="#8990a7"
            stroke="#b4c2dc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default RiskReportDocDark;
